<template>
  <div id="modal-sumber">
    <div class="row scroller" style="max-height: 70vh">
      <div v-if="is_error" class="col-md-12">File tidak ditemukan</div>
      <div class="col-md-12" v-else-if="data[0].source == 'media_tv'">
        <video
          v-if="
            data[0] && data[0].file_source && Array.isArray(data[0].file_source)
          "
          @error="videoError"
          style="width: 100%"
          controls=""
          :src="data[0].file_source[0]"
          muted
        >
          Your browser does not support HTML5 video.
        </video>
        <video
          v-else
          @error="videoError"
          style="width: 100%"
          controls=""
          :src="file_source"
          muted
        >
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div v-else class="col-md-12">
        <div
          class="list-files"
          v-if="
            data[0] && data[0].file_source && Array.isArray(data[0].file_source)
          "
        >
          <img
            v-for="(file, index) in data[0].file_source"
            :key="index"
            :src="file"
            alt="Post Image"
            @error="videoError"
            width="100%"
          />
        </div>
        <img
          v-else-if="!spaces_error && data[0].data_source != 'dgv'"
          :src="file_source"
          alt="Post Image"
          @error="videoError"
          width="100%"
        />
        <iframe
          v-else
          @error="videoError"
          :src="
            'https://drive.google.com/viewerng/viewer?embedded=true&url=' +
            file_source
          "
          type="application/pdf"
          width="100%"
          height="500px"
        />
      </div>
    </div>
    <div
      class="row m-t-10"
      v-if="!spaces_error && data[0].source == 'media_cetak'"
    >
      <div class="col-12" align="right">
        <button class="btn btn-success btn-icon-left" @click="downloadFile">
          <i class="bi bi-download"></i> Download
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal_sumber",
  props: {
    data: Array,
    default: function () {
      return [];
    },
  },
  data() {
    return {
      is_error: this.data[0].file_source == "" ? true : false,
      spaces_error: false,
    };
  },
  methods: {
    videoError: function () {
      console.log("video error");
    },
    downloadFile: function () {
      let file_src = this.file_source;
      if (
        this.data[0].data_source == "siputra" ||
        this.data[0].data_source == "dgv"
      ) {
        this.data[0].file_source.forEach(function (file) {
          window.open(file);
        });
      } else {
        window.open(file_src);
      }
    },
  },
  computed: {
    file_source: function () {
      let file_source = "no-video";
      let our_domain = "https://dev-kurasi.nyc3.digitaloceanspaces.com/jpgs/";
      let domain;
      if (this.data[0].source == "media_cetak") {
        domain = "https://pdf.antara-insight.id/pdf_images/";
      } else {
        domain = "https://";
      }
      switch (this.data[0].source) {
        case "media_tv":
          if (this.data[0].data_source == "factory") {
            if (this.data[0].file_source_type == "full_url") {
              file_source = this.data[0].file_source;
            } else {
              let filepart = this.data[0].file_source.split("-");
              let file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.data[0].file_source;
              file_source = file_src;
            }
          } else {
            let file_src;
            if (this.data[0].file_source.includes("https")) {
              file_src = this.data[0].file_source;
            } else {
              let filepart = this.data[0].file_source.split("-");
              file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.data[0].file_source;
            }
            file_source = file_src;
          }
          break;
        case "media_cetak":
          if ("data_source" in this.data[0]) {
            if (this.data[0].data_source == "dgv") {
              let filepart = this.data[0].file_source[0].split("-");
              let file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.data[0].file_source[0];
              file_source = file_src;
            } else if (this.data[0].data_source == "siputra") {
              file_source = our_domain + this.data[0].file_source[0];
            } else {
              file_source = our_domain + this.data[0].file_source[0];
            }
          } else {
            file_source = our_domain + this.data[0].file_source[0];
          }
          break;
        default:
          break;
      }
      return file_source;
    },
  },
};
</script>
